import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Table, Badge
} from "reactstrap"
import { Link } from "react-router-dom"
import apiResponse from '../../../../../services/apiResponse'
import DataTableBloc from '../Index/Blocs/DataTableBloc'
import moment from "moment"

class DetailView extends Component {
    dataTableBloc = new DataTableBloc();

    constructor(props) {
        super(props);
        this.state = {
            dataDetail: null,
            uuid: new URLSearchParams(window.location.search).get('uuid')
        };
    }

    componentDidMount() {
        if (this.state.uuid) {
            this.dataTableBloc.fetchDetail(this.state.uuid);
        }

        this.dataTableBloc.detailChannel.subscribe((result) => {
            if (result.status === apiResponse.COMPLETED) {
                this.setState({
                    dataDetail: result.data.response
                });
            }
        });
    }

    componentWillUnmount() {
        this.dataTableBloc.detailChannel.unsubscribe();
    }

    render() {
        const { dataDetail } = this.state;
        if (!dataDetail) {
            return (
                <Container fluid>
                    <div className="text-center p-4">
                        <div className="spinner-border text-primary" role="status"></div>
                    </div>
                </Container>
            );
        }

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={window.location.pathname}>
                                            <Button color="secondary">
                                                <i className="uil-arrow-left me-1"></i> Kembali
                                            </Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Detail Master Bagian Soal</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi detail data Bagian Soal
                                    </CardSubtitle>
                                    <hr />
                                    <Table responsive bordered className="mb-0">
                                        <tbody>
                                            <tr>
                                                <th style={{ width: '25%' }}>Nama Bagian Soal</th>
                                                <td><strong>{dataDetail.ms360_question_type_name}</strong></td>
                                            </tr>
                                            <tr>
                                                <th>Keterangan / Deskripsi</th>
                                                <td>{dataDetail.ms360_question_type_description || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th>Status</th>
                                                <td>
                                                    {dataDetail.ms360_question_type_status === 1 ? (
                                                        <Badge color="success">Aktif</Badge>
                                                    ) : (
                                                        <Badge color="danger">Tidak Aktif</Badge>
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Tanggal Dibuat</th>
                                                <td>{dataDetail.ms360_question_type_created ? moment(dataDetail.ms360_question_type_created).format('DD MMMM YYYY HH:mm') : '-'}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        );
    }
}

export default DetailView
